import AdditionalDataBanner from './AdditionalDataBanner'
export default AdditionalDataBanner
